<template>
  <div class="border-2 border-beige-academy-300 p-3 w-full
  flex justify-start">
    <ais-instant-search
      :search-client="searchClient"
      index-name="languages"
      class="w-full"
    >
      <ais-configure
        :hits-per-page.camel="7"
        :distinct="true"
        :restrict-searchable-attributes.camel="['name', 'nativeName']"
      />
      <ais-autocomplete>
        <template slot-scope="{ indices, refine }">
          <vue-autosuggest
            :suggestions="indicesToSuggestions(indices)"
            @input="refine"
            @selected="$emit('selected', $event)"
            :input-props="{
              style: 'width: 100%; outline:none; border-bottom: 1px solid gray;',
              placeholder: 'Search...',
            }"
            :get-suggestion-value="getSuggestionValue"
          >
          <template slot-scope="{ suggestion }">
            <button
            class="pl-2 pr-4 py-2 w-84 bg-gray-100 text-left hover:bg-gray-200
            hover:font-semibold w-full">
              {{ suggestion.item['nativeName']}}
            </button>
          </template>
          </vue-autosuggest>
        </template>
      </ais-autocomplete>
    </ais-instant-search>
  </div>
</template>

<script>
import AlgoliaMixin from '@/mixins/AlgoliaMixin';

export default {
  mixins: [AlgoliaMixin],

  props: ['value'],

  watch: {
    emptyArray() {
      this.$emit('input', this.emptyArray);
    },
  },

  methods: {
    getSuggestionValue(suggestion) {
      return suggestion.item.nativeName;
    },
  },
};
</script>
